import { css } from 'aphrodite';
import * as React from 'react';
import { bs } from '../../../../../styles/styles';
import { MobileImageUploadButtons } from './MobileImageUploadButtons';
import { mobileStyles } from '../styles';

const MAX_MOBILE_IMAGES = 5;

interface MobileActionButtonsProps {
	onScheduleForLater: () => void;
	onPostNow: () => void;
	onUploadMedia?: () => void;
	onFreeImages?: () => void;
	canPostNow: boolean;
	canSchedule: boolean;
	isSchedulingInProgress: boolean;
	showPostNow: boolean;
	imageCount?: number;
}

const MobileActionButtons: React.FC<MobileActionButtonsProps> = ({
	onScheduleForLater,
	onPostNow,
	onUploadMedia,
	onFreeImages,
	canPostNow,
	canSchedule,
	isSchedulingInProgress,
	showPostNow,
	imageCount = 0,
}) => {
	// Show image upload buttons when under the max limit and not scheduling
	const shouldShowImageButtons = imageCount < MAX_MOBILE_IMAGES && !isSchedulingInProgress;

	return (
		<div className={css(mobileStyles.actionButtonsContainer)}>
			{shouldShowImageButtons && (
				<MobileImageUploadButtons
					onClickFreeImage={onFreeImages}
					onClickMedia={onUploadMedia}
					currentImageCount={imageCount}
					maxImages={MAX_MOBILE_IMAGES}
				/>
			)}

			<div className={css(mobileStyles.actionButtons)}>
				<button
					className={css(mobileStyles.scheduleButton)}
					onClick={onScheduleForLater}
					disabled={!canSchedule || isSchedulingInProgress}
				>
					{isSchedulingInProgress ? 'Scheduling...' : 'Schedule for Later'}
				</button>

				{showPostNow && (
					<button
						className={css(bs.ctaButtonReverse)}
						onClick={onPostNow}
						disabled={!canPostNow || isSchedulingInProgress}
					>
						Post Now
					</button>
				)}
			</div>
		</div>
	);
};

export { MobileActionButtons };
